export default __webpack_public_path__ + "static/tourartist-1364d7552e7bcf0499bbb0734a1e9f90.jpg";